import { useCallback, useState } from "react";
import UserAvatar from "../UserAvatar/UserAvatar.component";
import DateAndTimeViewer from "../DateAndTimeViewer/DateAndTimeViewer.component";
import useStyles from "./CommentBox.styles";
import { Button, Divider } from "@material-ui/core";
import { ArrowBendDownRight } from "phosphor-react";

const SingleComment = ({ eachComment, setDisplayImage, setOpen }) => {
  const classes = useStyles();
  const [showReplies, setShowReplies] = useState(false);

  const getDisplayTime = useCallback((time) => {
    if (time.includes(":")) {
      return time;
    }
    let seconds = 0;
    let minutes = 0;
    if (time % 60) {
      minutes = parseInt(time / 60);
      seconds = parseInt(time % 60);
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
    }
    return `${minutes}:${seconds}`;
  }, []);

  return (
    <div
      id={eachComment.id}
      style={{ boxSizing: "border-box", height: "max-content", width: "100%" }}
    >
      <div className={classes.commentHead}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <UserAvatar
            avatar={eachComment?.author?.avatar}
            firstName={eachComment?.author?.first_name[0]}
            lastName={eachComment?.author?.last_name[0]}
          />
          <span className={classes.userName}>
            {eachComment.author.first_name} {eachComment.author.last_name}
          </span>
        </div>
        <span className={classes.time}>
          <DateAndTimeViewer dateAndTime={eachComment.created_at} />
        </span>
      </div>

      <div
        style={{
          marginLeft: "40px",
          padding: "8px 0px",
        }}
      >
        {/* add show more on big comments */}
        <div style={{ display: "flow" }}>
          {eachComment?.description?.split("<p>")[0] ? (
            <span className={classes.annotationText}>
              {getDisplayTime(eachComment?.description?.split("<p>")[0])}
            </span>
          ) : null}
          <span
            className={classes.commentText}
            dangerouslySetInnerHTML={{
              __html: eachComment?.description
                .split("<p>")[1]
                ?.replace("<p>", "<div>")
                ?.replace("</p>", "</div>"),
            }}
          />
        </div>
      </div>

      {eachComment.attachment && (
        <>
          <img
            className={classes.image}
            onClick={(e) => {
              setOpen(true);
              setDisplayImage(eachComment.attachment);
            }}
            alt="projectImage"
            src={eachComment.attachment}
            height="150px"
            width="230px"
            onContextMenu={(e) => e.preventDefault()}
          />
          <br />
        </>
      )}
      <Button
        onClick={(e) => {
          e.stopPropagation();
          setShowReplies(!showReplies);
        }}
        className={classes.showHideButton}
        disabled={eachComment?.replies?.length ? false : true}
      >
        {eachComment?.replies?.length ? (
          <>
            {showReplies
              ? "Hide Replies"
              : `Show ${eachComment?.replies?.length} Replies`}
          </>
        ) : (
          "No Replies"
        )}
      </Button>
      <div
        style={{
          marginLeft: "20px",
          maxHeight: showReplies ? "300px" : "0px",
          overflowY: "auto",
          marginRight: "6px",
          transition: "max-height 0.5s ease-in-out",
        }}
      >
        {eachComment?.replies?.map((reply) => (
          <SingleReply reply={reply} eachComment={eachComment} />
        ))}
      </div>
    </div>
  );
};

const SingleReply = ({ reply, eachComment }) => {
  const classes = useStyles();

  return (
    <div id={reply.id} className={classes.notSelectedComment}>
      <div className={classes.commentHead}>
        <div className={classes.repliesHead}>
          <ArrowBendDownRight size={20} className={classes.colorText} />
          <UserAvatar
            avatar={reply?.author?.avatar}
            firstName={
              reply?.author?.first_name ? reply?.author?.first_name[0] : ""
            }
            lastName={
              reply?.author?.last_name ? reply?.author?.last_name[0] : ""
            }
          />

          <span style={{ margin: "0px 2px" }} className={classes.commentText}>
            {reply.author.first_name} {reply.author.last_name}
          </span>
        </div>
        <span className={classes.time}>
          <DateAndTimeViewer dateAndTime={eachComment.created_at} />
        </span>
      </div>

      <div className={classes.replyDescription}>
        {/* add show more on big comments */}
        <span
          className={classes.commentText}
          dangerouslySetInnerHTML={{
            __html: reply?.description?.split("<p>")[1]?.split("</p>")[0],
          }}
        />
      </div>

      <Divider />
    </div>
  );
};

export default SingleComment;
